<template>
	<!-- 自定义图片 -->
	<a-empty v-if="customImage" :description="desc" :class="{'custom-image-container': customImage}">
        <template #image>
            <div class="custom-image">
                <img src="@/assets/images/common/custom-image.png" alt="暂无数据">
            </div>
        </template>
    </a-empty>
    <!-- 默认 -->
	<a-empty v-else :image="simpleImage" :description="desc" />
</template>

<script>
import { Empty } from 'ant-design-vue';
export default {
	name: 'SimpleImageEmpty',
	props: {
		desc: {
			type: String,
			default: '暂无数据',
		},
        customImage: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
		};
	},
};
</script>

<style lang="scss">
.custom-image-container {
    height: 390px;
    @include fcc();
    flex-direction: column;
    .ant-empty-image {
        height: 160px;
    }
    .custom-image {
        img {
            width: 195px;
            height: 160px;
        }
    }
}
</style>